__turbopack_context__.v({
  "className": "roboto_f9a1aa8f-module__BVHI7a__className",
});
